export default function SectionDivider({ label }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginTop: "100px",
        marginBottom: "100px",
        width: "100%"
      }}
    >
      <div
        style={{
          flex: 1,
          height: 4,
          backgroundColor: "#333"
        }}
      />

      <div
        style={{
          padding: "0 16px",
          fontSize: 48,
          fontWeight: 700,
          letterSpacing: 1,
          textTransform: "uppercase",
          whiteSpace: "nowrap"
        }}
      >
        {label}
      </div>

      <div
        style={{
          flex: 1,
          height: 4,
          backgroundColor: "#333"
        }}
      />
    </div>
  );
}
